module.exports = {"610828001":"佳州街道","610828101":"坑镇","610828102":"店镇","610828103":"乌镇","610828104":"金明寺镇","610828105":"通镇","610828106":"王家砭镇","610828107":"方塌镇","610828108":"朱家坬镇","610828109":"螅镇","610828110":"朱官寨镇","610828111":"刘国具镇","610828112":"木头峪镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610828.json
// module id = 3006
// module chunks = 0